module.exports = __webpack_public_path__ + "static/media/mastercard.3bbeab8f.svg";